module.exports = __webpack_public_path__ + "img/Berry.699f6f96.webp";